<template>
  <NavHeader />
  <router-view />
  <NavFooter v-if="!isNewsPage" />
</template>

<script setup>
import NavHeader from "@/components/NavHeader.vue";
import NavFooter from "@/components/NavFooter.vue";
import { computed } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();
const isNewsPage = computed(() => route.path.startsWith("/news"));
</script>

<style lang="scss">
#app {
  font-family: "方正幼圆", "华文幼圆", "PingFang SC Light",
    "Microsoft YaHei Light", "HYYuanTi", sans-serif;
  text-align: center;
  color: #000;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #42b983;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
